import React from 'react';
import PageContainer from '../../components/container/PageContainer';
import Navbar from '../../layouts/full-layout/header/homeHeader';
import { Box, Typography } from '@mui/material';
import Footer from '../../layouts/full-layout/footer/Footer';
import BgImage from '../../assets/backgrounds/poster.jpg';

const About = () => {
  return (
    <PageContainer title="About" description="This is About Page">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        <Navbar />

        {/* Main Content */}
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundImage: `url(${BgImage})`, // Make sure the background image is wrapped in `url()`
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            marginTop: window.innerWidth < 768 && "90px" 
          }}
        >
          <Typography variant="h1" fontWeight="bold">
            About
          </Typography>

          <Box p={5}>
            <Typography variant="h3">
              The Behtar@75 Campaign was launched by the Ministry of Culture to honour and celebrate
              the country's 75th anniversary of independence. It offers a once-in-a-lifetime
              opportunity to contribute, participate, and take on challenges in the name of a better
              India. It provides real-time updates and assists in contributing to numerous national
              tasks and campaigns. Through this campaign, every Indian citizen may contribute their
              talents to make India a Behtar India by the time we celebrate our 75th year of
              independence. Every Indian has the opportunity to take the ""Behtar@75 Pledge"" as
              part of the campaign. It also includes visually appealing infographics that depict the
              influence or change in India after 75 years of independence (#behtar@75). There will
              be a plethora of fascinating features that will empower citizens to make a positive
              influence in society. <br />
              Every 15 days, there will be a series of activities:
              <ul>
                <li>Power</li>
                <li>Pride</li>
                <li>Courage</li>
                <li>Confidence</li>
              </ul>
            </Typography>
          </Box>
        </Box>

        {/* Footer */}
        <Footer />
      </Box>
    </PageContainer>
  );
};

export default About;
